var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressItem"},[_c('b',{attrs:{"id":"name"}},[_vm._v(_vm._s(_vm.item.text)+" ")]),(_vm.hasIcon(_vm.item.icon))?_c('span',[_c('font-awesome-icon',{attrs:{"icon":_vm.item.icon}})],1):_vm._e(),_c('b-progress',{attrs:{"value":_vm.item.value,"height":"5px","variant":_vm.item.variant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }